import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserState } from './user.state';
import { PermissionsService } from './permissions.service';

export const mercerGuard: CanActivateFn = () => {
  const userState = inject(UserState);
  const permissionsService = inject(PermissionsService);
  const toast = inject(ToastrService);
  const router = inject(Router);

  if (userState.isDynamicMercerAccessAllowed() || permissionsService.isSuperAdmin()) {
    return true;
  }
  toast.error('Not authorized.');
  return new RedirectCommand(router.createUrlTree(['']));
};
